'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contentthreemobile = () => {
  const line1 =
    'https://osscdn.weiyouzhihui.com/editorVideo/1736414400632/Frame%201312321283%402x.png';
  const line2 =
    'https://osscdn.weiyouzhihui.com/editorVideo/1736414430259/Frame%201312321282%402x.png';
  const items = [
    {
      title: '渠道活码',
      dsc: '可创建带参数的客服码进行分流；可设置欢迎语、标签、统计数据',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417405131/Frame%201312321084%402x.png',
    },
    {
      title: '好友欢迎语',
      dsc: '可为员工配置好友欢迎语，支持发送文字、图片及图文消息',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417423009/Frame%201312321085%402x.png',
    },
    {
      title: '客户画像',
      dsc: '可查看客户的销售、加群、标签变化等动态及客户是否打开文件，商城购买记录等',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417449477/Frame%201312321086%402x.png',
    },
    {
      title: '删除提醒',
      dsc: '实时通知员工客户删除情况，便于员工及时挽回客户',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417498210/Frame%201312321087%402x.png',
    },
    {
      title: '客户SOP',
      dsc: '可创建自动化客户跟进SOP，员工一键发送触达内容，高效服务客户',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417515911/Frame%201312321091%402x.png',
    },
    {
      title: '群发SOP',
      dsc: '可根据需求给社群制定不同的群发SOP计划',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417540179/Frame%201312321090%402x.png',
    },
    {
      title: '智能雷达',
      dsc: '智能记录客户访问动作，客户轨迹追踪+智能提醒，及时跟进重点商机',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736417558808/Frame%201312321092%402x.png',
    },
  ];
  return (
    <section className="w-full px-[20px]">
      <motion.div
        className="text-center mb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] mb-[16px] font-medium text-black/85">
          微友智汇SCRM解决方案
        </h2>
        <div className="flex flex-col gap-[24px]">
          {items.map((item, index) => (
            <div key={index} className="w-full flex justify-start">
              <DynamicImage src={item.icon} className="w-[68px] h-[68px]"></DynamicImage>
              <div className="text-left pl-[16px] pt-[8px]">
                <p className="text-[14px] text-[rgba(0,0,0,0.85)]">{item.title}</p>
                <p className="text-[12px] text-[rgba(0,0,0,0.65)]">{item.dsc}</p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Contentthreemobile;
